import ProjectOverview from '../components/ProjectOverview';
import WhyFloretTown from '../components/WhyFloretTown';
import Construction from '../components/Construction';
import MasterPlan from '../components/MasterPlan';
import Amenities from '../components/Amenities';
import Specifications from '../components/Specifications';
import SeoHelper from '../common/SeoHelper';
const ProjectDetails= ()=>{
    return(
        <div>
            <SeoHelper/>
            <ProjectOverview/>
            <WhyFloretTown/>
            <Construction/>
            <MasterPlan/>
            <Amenities/>
            <Specifications/>
        </div>
    )
};
export default ProjectDetails;